export default "__VITE_ASSET__55e47fe4__"